module.exports = __webpack_public_path__ + "static/media/Cloudy.83a5d69a.jpg";